import {PortalDashboard} from "../components/PortalDashboard.tsx";

export const IndexPage = () => {
    return (<PortalDashboard/>);
};
